import da from "../../../locales/da/checkout.json";
import de from "../../../locales/de/checkout.json";
import en from "../../../locales/en/checkout.json";
import es from "../../../locales/es/checkout.json";
import et from "../../../locales/et/checkout.json";
import fi from "../../../locales/fi/checkout.json";
import fr from "../../../locales/fr/checkout.json";
import hr from "../../../locales/hr/checkout.json";
import lt from "../../../locales/lt/checkout.json";
import lv from "../../../locales/lv/checkout.json";
import nl from "../../../locales/nl/checkout.json";
import no from "../../../locales/no/checkout.json";
import sv from "../../../locales/sv/checkout.json";

export const resources: Partial<
  Record<I18nLocale, Record<string, string>>
> = { da, de, en, es, et, fi, fr, hr, lt, lv, nl, no, sv };
